export const OPEN_DRAWER = 'LEFT_DRAWER.OPEN_DRAWER';
export const CLOSE_DRAWER = 'LEFT_DRAWER.CLOSE_DRAWER';
export const OPEN_SUBMENU = 'LEFT_DRAWER.OPEN_SUBMENU';
export const CLOSE_SUBMENU = 'LEFT_DRAWER.CLOSE_SUBMENU';
